export default __webpack_public_path__ + "static/media/Nose_6.3075bb18.svg";